export default __webpack_public_path__ + "static/media/logo-purple.63b98e29.png";